import ReactPaginate from "react-paginate";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationProps {
  totalPages: number;
  onPageChange: (page: number) => void;
  initialPage?: number;
  className?: string;
  previousLabel?: string | JSX.Element;
  nextLabel?: string | JSX.Element;
  breakLabel?: string;
  forcePage?: number;
}

export const Pagination: React.FC<PaginationProps> = ({
  totalPages,
  onPageChange,
  initialPage = 0,
  className = "",
  previousLabel = <ChevronLeft className="w-5 h-5" />,
  nextLabel = <ChevronRight className="w-5 h-5" />,
  breakLabel = "...",
  forcePage
}) => {
  const pageCount = Math.max(1, totalPages);

  const handlePageChange = (event: { selected: number }) => {
    onPageChange(event.selected + 1);
  };

  const prefix = "pagination";

  return (
    <>
      <style>{`
        .${prefix} {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
        }

        .${prefix}__page-item .${prefix}__page-link {
          padding: 0.5rem 0.75rem;
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          background-color: #ffffff;
          border: 1px solid #d1d5db;
          border-radius: 0.375rem;
          text-decoration: none;
          cursor: pointer;
        }

        .${prefix}__page-item .${prefix}__page-link:hover {
          background-color: #ecfdf5;
          color: #047857;
        }

        .${prefix}__active .${prefix}__page-link {
          background-color: #10b981;
          color: #ffffff;
          border-color: #10b981;
        }

        .${prefix}__previous-item .${prefix}__previous-link,
        .${prefix}__next-item .${prefix}__next-link {
          padding: 0.5rem 0.75rem;
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          background-color: #ffffff;
          border-radius: 0.375rem;
          text-decoration: none;
          cursor: pointer;
        }

        .${prefix}__previous-item .${prefix}__previous-link:hover,
        .${prefix}__next-item .${prefix}__next-link:hover {
          background-color: #ecfdf5;
          color: #047857;
        }

        .${prefix}__break-item .${prefix}__break-link {
          padding: 0.5rem 0.75rem;
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
        }

        .${prefix}__disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      `}</style>

      <ReactPaginate
        containerClassName={`${prefix} ${className}`}
        pageClassName={`${prefix}__page-item`}
        pageLinkClassName={`${prefix}__page-link`}
        activeClassName={`${prefix}__active`}
        activeLinkClassName={`${prefix}__page-link`}
        previousClassName={`${prefix}__previous-item`}
        previousLinkClassName={`${prefix}__previous-link`}
        nextClassName={`${prefix}__next-item`}
        nextLinkClassName={`${prefix}__next-link`}
        breakClassName={`${prefix}__break-item`}
        breakLinkClassName={`${prefix}__break-link`}
        disabledClassName={`${prefix}__disabled`}
        onPageChange={handlePageChange}
        pageCount={pageCount}
        initialPage={initialPage}
        forcePage={forcePage}
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        breakLabel={breakLabel}
        previousAriaLabel="Previous page"
        nextAriaLabel="Next page"
      />
    </>
  );
};

export default Pagination;